import React from 'react'
import IconBase from '../IconBase'

const svgContent = <svg viewBox="0 0 1024 1024" width="1em" height="1em" focusable="false" fill="currentColor" aria-hidden="true"><path d="M503.488 726.485 757.781 768V533.227H503.488v193.28zm0-428.224V490.88h254.293V256l-254.293 42.24zm-268.8 192.555h215.019v-185.6l-215.04 35.69v149.91h.021zm0 193.685 214.997 35.03V533.248H234.667v151.253h.021z" /></svg>

const Windows = React.forwardRef((props, ref) => {
  return (
    <IconBase name="windows" {...props} ref={ref}>
      {svgContent}
    </IconBase>
  )
})

Windows.displayName = 'IconWindows'

export default Windows
